module.exports = __webpack_public_path__ + "img/clients.2bcab885.svg";